'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _Languages = require('../Icons/dist/components/Languages');

var _Languages2 = _interopRequireDefault(_Languages);

var _IconWithOptions = require('../IconWithOptions');

var _IconWithOptions2 = _interopRequireDefault(_IconWithOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguagePicker = function (_WixComponent) {
  _inherits(LanguagePicker, _WixComponent);

  function LanguagePicker() {
    _classCallCheck(this, LanguagePicker);

    return _possibleConstructorReturn(this, (LanguagePicker.__proto__ || Object.getPrototypeOf(LanguagePicker)).apply(this, arguments));
  }

  _createClass(LanguagePicker, [{
    key: 'createDividedChildren',
    value: function createDividedChildren(availableOptions) {
      var dividerChild = _react2.default.cloneElement(this.props.children[0], {
        children: '-',
        languageKey: '-',
        linkTo: '-'
      });

      var dividedChildren = [].concat(_toConsumableArray(availableOptions));
      dividedChildren.forEach(function (_, index) {
        return dividedChildren.splice(index * 2 + 1, 0, dividerChild);
      });
      dividedChildren.pop();

      return dividedChildren;
    }
  }, {
    key: 'createIconWithOptionsOptions',
    value: function createIconWithOptionsOptions(children) {
      var _this2 = this;

      var availableOptions = children.filter(function (opt) {
        return opt.props.languageKey !== _this2.props.selectedId;
      });
      var dividedChildren = this.createDividedChildren(availableOptions);

      return dividedChildren.map(function (languagePickerOption) {
        var _languagePickerOption = languagePickerOption.props,
            languageName = _languagePickerOption.children,
            languageKey = _languagePickerOption.languageKey,
            linkTo = _languagePickerOption.linkTo;


        return _react2.default.createElement(
          _IconWithOptions2.default.Option,
          { key: languageKey, id: languageKey, linkTo: linkTo },
          languageName
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _IconWithOptions2.default,
        rest,
        _react2.default.createElement(
          _IconWithOptions2.default.Icon,
          null,
          _react2.default.createElement(_Languages2.default, { size: '18' })
        ),
        this.createIconWithOptionsOptions(children)
      );
    }
  }]);

  return LanguagePicker;
}(_WixComponent3.default);

exports.default = LanguagePicker;


LanguagePicker.displayName = 'LanguagePicker';

LanguagePicker.defaultProps = {
  itemHeight: 'big',
  maxHeightPixels: 566
};

LanguagePicker.propTypes = _extends({}, _IconWithOptions2.default.propTypes, {

  /**
    * Specify the languages list to render
    *
    * children __must__ be `<LanguagePicker.Option/>` component with:
    *   * `languageKey` - string, required
    *   * `children` - string
    */
  children: _propTypes2.default.arrayOf(function (propValue, key) {
    if (propValue[key].type !== LanguagePicker.Option) {
      return new Error('LanguagePicker: Invalid Prop children was given. Validation failed on child number ' + key);
    }
  }).isRequired
});

LanguagePicker.Option = function () {
  return null;
};
LanguagePicker.Option.displayName = 'LanguagePicker.Option';

LanguagePicker.Option.propTypes = {
  languageKey: _propTypes2.default.string.isRequired,
  linkTo: _propTypes2.default.string,
  children: _propTypes2.default.string
};